import {createContext} from 'react'
function noop() {}
export const FieldWrapperContext = createContext({
    openDropdown: noop,
    isOpened: false
});